import { render, staticRenderFns } from "./SaveDesktopTips.vue?vue&type=template&id=a5259304&scoped=true&"
import script from "./SaveDesktopTips.vue?vue&type=script&lang=js&"
export * from "./SaveDesktopTips.vue?vue&type=script&lang=js&"
import style0 from "./SaveDesktopTips.vue?vue&type=style&index=0&id=a5259304&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5259304",
  null
  
)

export default component.exports